import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OwnershipLevel } from '@fitness-force/enum';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError, Observable } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class WebhookConfigService {
  private http = inject(HttpClient);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  ListWebhookConfigByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_WEBHOOK_CONFIGS;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_WEBHOOK_CONFIGS
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.WEBHOOK_CONFIG.GET_WEBHOOK_CONFIGS
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.WEBHOOK_CONFIG.GET_WEBHOOK_CONFIGS
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.get<any>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  createWebhookConfig(ownership:OwnershipLevel, payload:any, tenantId:number, franchiseGroupId:number) {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.CREATE_WEBHOOK_CONFIG;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.CREATE_WEBHOOK_CONFIG
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.WEBHOOK_CONFIG.CREATE_WEBHOOK_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.WEBHOOK_CONFIG.CREATE_WEBHOOK_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
    }

    return this.http
      .post(
        url,
        payload,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateWebhookConfig(ownership:OwnershipLevel, payload:any, tenantId:number, franchiseGroupId:number, webhookConfigId:number) {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.UPDATE_WEBHOOK_CONFIG
          .replace('{webhook_id}', webhookConfigId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.UPDATE_WEBHOOK_CONFIG
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{webhook_id}', webhookConfigId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.WEBHOOK_CONFIG.UPDATE_WEBHOOK_CONFIG
          .replace('{tenant_id}', tenantId.toString())
          .replace('{webhook_id}', webhookConfigId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.WEBHOOK_CONFIG.UPDATE_WEBHOOK_CONFIG
          .replace('{tenant_id}', tenantId.toString())
          .replace('{webhook_id}', webhookConfigId.toString());
        break;
    }

    return this.http.put(url, payload, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  } 
}
